import React, { useRef } from "react";
import { LineChart } from "@mui/x-charts";
import {
  markElementClasses,
} from '@mui/x-charts/LineChart';
import { Box, useMediaQuery, useTheme } from "@mui/material";
import DownloadMenu from "./DownloadMenu";
import useWindowDimensions from "../../../genericComponents/getWindowDimensions";

const LineChartCard = ({ type, meterType, charts, height }) => {
  const { width } = useWindowDimensions();
  const theme = useTheme();
  
  const greaterThanMid = useMediaQuery(theme.breakpoints.up("md"));
  const greaterThanLg = useMediaQuery(theme.breakpoints.up("lg"));
  const ref = useRef();
  const palette2 = [
    "#1b4962",
    "#006e79",
    "#009060",
    "#81a721",
    "#ffa600",
    "#c27101",
    "#884f01",
    "#184056",
    "#173f54",
    "#173d52",
    "#163c50",
    "#163a4e",
    "#15394c",
    "#15374a",
    "#143649",
    "#133547",
    "#133345",
    "#123243",
    "#123041",
    "#112f3f",
    "#112d3d",
    "#102c3b",
    "#102a39",
    "#0f2937",
    "#0f2735",
    "#0e2633",
  ];
       
  if (!charts || !charts[0]) {
    return <div style={{ textAlign: "center", alignContent: "center", height: height, width: "100%" }}>No Data</div>;
  }

  // Filter valid data points
  const validCharts = charts.map(chart => ({
    ...chart,
    data: chart.data.filter(item => item && item.x !== null && item.x !== undefined && item.y !== null && item.y !== undefined)
  }));

  // Find max length
  const maxLength = Math.max(...validCharts.map(c => c.data.length));
  
  // Get labels from first chart (now filtered)
  const labels = validCharts[0]?.data.map(x => x.x) || []; 

  // Build series with matching lengths
  const series = [];
  for (let i = 0; i < validCharts.length; i++) {
    const chartData = validCharts[i].data;
    
    // Pad with nulls if needed to match maxLength
    const paddedData = [];
    for (let j = 0; j < maxLength; j++) {
      paddedData.push(chartData[j]?.y || null);
    }
    
    series.push({ 
      label: validCharts[i].label,
      color: palette2[i], 
      data: paddedData
    });
  }

  let chartWidth = width;
  if (greaterThanMid) {
    if (greaterThanLg) {
      chartWidth = (width - 360) / 12 * 9;
    } else {
      chartWidth = (width - 360);
    }
  } else {  
    chartWidth = width - 40;
  }
  const unit = meterType == "GAS" ? "m3" : "kWh";


  return (    
    <>
      <Box sx={{ display: "flex", marginRight: theme.spacing(1), justifyContent: 'flex-end', width: "100%" }}>
        <DownloadMenu graph={ref} type={type} data={series}/>                
      </Box>    
      <LineChart 
        skipAnimation 
        width={chartWidth} 
        height={height}  
        ref={ref} 
        margin={{ left: 100, right: 120, bottom: 100 }}
        sx={{       
          flexGrow: 1,
          [`& .${markElementClasses.root}`]: {
            scale: '0.1',
            fill: '#fff',
            strokeWidth: 2,
          },
        }}
        yAxis={[
          {
            valueFormatter: (value, context) =>
              value + " " + unit
          }
        ]}
        xAxis={[{
          scaleType: 'point',
          data: labels
        }]} 
        series={series} 
      />
    </>
  );
}

export default LineChartCard;